import type { Router } from 'vue-router';

import getPageTitle from '@/utils/get-page-title';

export function createPageGuard(router: Router) {
  // 跳转之后
  router.afterEach((to) => {
    // set page title
    document.title = getPageTitle(
      to.meta.title,
      to.query.redirectUrl ? to.query.redirectUrl : ''
    ) as string;
  });
}
